import React, { useEffect, useState } from "react";
import styles from "../../styles/register.module.css";
import { useNavigate } from "react-router";
import { API_Path } from "../../const";
import { PostApi } from "../../api/api-service";
import { toast } from "react-toastify";
import Logo from "./Logo";
import SideImg from "../../assets/images/verification.png";
import Loading from "../../components/loader/Loading";

//#region  Global veriable

var valueUrl;

//#endregion Global veriable

export default function EmailVerificationModal() {
    const navigate = useNavigate();
    const [errorMsg, setErrorMsg] = useState();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const sPageURL = window.location.href;
        const indexOfLastSlash = sPageURL.lastIndexOf("/");

        if (indexOfLastSlash > 0 && sPageURL.length - 1 !== indexOfLastSlash) {
            const extractedValue = sPageURL.substring(indexOfLastSlash + 1);
            valueUrl = extractedValue;
        }
    }, []);

    useEffect(() => {
        setLoading(false);
        registerVerificationData();
    }, []);

    const registerVerificationData = async () => {
        const data = {
            EncryptedUrl: valueUrl,
        };
        try {
            const res = await PostApi(API_Path.userEmailVerify, data);
            if (res) {
                setLoading(false);
                if (res.data.Isvalid === true) {
                    navigate("/register-verify");
                    toast.success(res.data.Successes[0]);
                } else {
                    setErrorMsg(res.data.Errors);
                }
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const handleRedirect = () => navigate("/resend-email-verify");

    return (
        <React.Fragment>
            {loading && <Loading />}

            <div className="container-fluid">
                <div className="row">
                    <div className={`${styles.col_width_left} ${styles.col_width_flex}`}>
                        <div className={styles.main_box}>
                            <div className={styles.lr_logo}>
                                <Logo />
                            </div>
                            <div className="mb-4">
                                <h3>
                                    E-mail Verification
                                </h3>
                            </div>

                            <div className={styles.verify_mail_body}>
                                {errorMsg?.lenght > 0 ? (
                                    <>
                                        <p className="mb-4">Your account take some time for verify e-mail.</p>
                                        <div className={styles.loginBtn}>
                                            <button type="submit" className="button primary_button w-100 m-0">
                                                Submit
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <p className="mb-4">User account e-mail verification failed.</p>
                                        {errorMsg && (
                                            <div className={`${styles.alert} ${styles.alert_danger}`}>
                                                <span>{errorMsg[0] ?? "Something went wrong."}</span>
                                            </div>
                                        )}
                                        <div className={styles.loginBtn}>
                                            <button type="submit" className="button primary_button w-100 m-0" onClick={() => handleRedirect()}>
                                                Sead Verification Link
                                            </button>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className={`${styles.col_width_right} p-0 d-lg-block d-none`}>
                        <div className={styles.side_img}>
                            <img src={SideImg} alt="JAMSKE" className="img-fluid" />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
